import { PlusIcon } from '@heroicons/react/outline';
import { ClipboardEvent, useState } from "react"
import { toast } from "react-toastify";

const ScanQrCode = (props: any) => {
  const { setValue } = props
  const [waybillNumber, setWaybillNumber] = useState("")
  const handleChange = (event: any) => {
    setWaybillNumber(event.target.value);
  };
  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      let lasttText = waybillNumber[waybillNumber?.length - 1]
      if (lasttText !== ",") {
        setWaybillNumber(waybillNumber.concat(","))
        setValue("tracking_number__in", waybillNumber)
      }
    }
  };

  const handleClear = () => {
    setWaybillNumber("")
    setValue("tracking_number__in", null)
  }

  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault()
    toast.error("Copy and paste is not allowed here")
  }

  return (
    <div className="invisible md:visible w-full text-left -mt-2 px-4 relative">
      <input
        placeholder={"Scan Barcode"}
        type={"text"}
        onPaste={preventCopyPaste}
        value={waybillNumber}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className="w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1"
      />
      {waybillNumber && <PlusIcon
        className="h-5 w-5 text-gray-400 rotate-45 absolute top-3 right-5"
        aria-hidden="true"
        onClick={handleClear}
      />}
    </div>
  )
}

export default ScanQrCode
